import { createSelector } from 'utils/app.util';

export const getLessonsFromState = createSelector(
  (state) => state.getIn(['projects', 'lessons', 'data']),
  (lessons) => lessons,
);
